import { render, staticRenderFns } from "./PromoModalNew.vue?vue&type=template&id=8d05dd9a&"
import script from "./PromoModalNew.vue?vue&type=script&lang=js&"
export * from "./PromoModalNew.vue?vue&type=script&lang=js&"
import style0 from "./PromoModalNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports